'use client';
/* eslint-disable */

import {
   Box,
   Button,
   Flex,
   IconButton,
   Table,
   Tbody,
   Td,
   Text,
   Th,
   Thead,
   Tr,
   useColorModeValue,
   useDisclosure,
   Select,
   Grid,
} from '@chakra-ui/react';
import { DeleteIcon, EditIcon } from '@chakra-ui/icons';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import React, { useEffect, useState } from 'react';
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import ModelMasterForm from './ModelMasterForm';
import { useDispatch, useSelector } from 'react-redux';
import { renderFormControl } from '../../../../../utils/DynamicFormData';
import { deleteModel, getModel, getSingleModel } from '../../../../../redux/actions/model';
import DeleteDialog from '../../components/DeleteDialog';
import { downloadPDF, downloadExcel, usePagination, useFilterData } from '../../../../../utils/DataTableUtils';
import ViewSingleData from '../../components/ViewSingleData';

// filter
import filter from 'assets/img/nfts/filter.svg';
import filter1 from 'assets/img/nfts/filter1.svg';
import nodata from 'assets/img/nfts/no data.svg';
import { GridItem, Input, FormLabel } from '@chakra-ui/react';
//filter end

const columnHelper = createColumnHelper();

export default function ModelMaster({ columnsData }) {
   const [sorting, setSorting] = React.useState([]);
   const dispatch = useDispatch();
   const modelData = useSelector((state) => state.model.list || []);
   const [data, setData] = React.useState([...modelData]);
   const [currentRow, setCurrentRow] = React.useState(null);
   const [focusedInput, setFocusedInput] = React.useState(null);
   // const [pageSize, setPageSize] = React.useState(10);
   const [currentPage, setCurrentPage] = React.useState(0);
   const [searchQuery, setSearchQuery] = React.useState('');
   const { isOpen, onOpen, onClose } = useDisclosure();
   const [isDeleteDialogOpen, setDeleteDialogOpen] = React.useState(false); // State to manage delete confirmation
   const [selectedRowId, setSelectedRowId] = React.useState(null);
   const [isEditMode, setIsEditMode] = React.useState(false);
   const [isOpenSingleView, setIsOpenSingleView] = React.useState(false);
   const singleEntity = useSelector((state) => state?.model?.single || {});

   // Use the custom hooks
   const filteredData = useFilterData(data, searchQuery, columnsData); // Filtered data
   const { paginatedData, handlePageSizeChange, handlePageChange, pageSize } = usePagination(data, filteredData); // Pagination
   const totalPages =
      pageSize >= filteredData.length // If pageSize is greater than or equal to filteredData length
         ? 1
         : Math.ceil(filteredData.length / pageSize);

   useEffect(() => {
      dispatch(
         getModel({
            page: currentPage + 1,
            limit: pageSize,
            search: searchQuery,
            sortBy: sorting.length ? sorting[0]?.id : 'id', // Default to 'id' if no sorting
            sortOrder: sorting.length ? (sorting[0]?.desc ? 'desc' : 'asc') : 'asc',
         }),
      );
   }, [dispatch, currentPage, pageSize, searchQuery, sorting]);

   // useEffect(() => {
   //   setData([...modelData]);
   // }, [modelData]);

   const handleDelete = async () => {
      if (selectedRowId !== null) {
         try {
            await dispatch(deleteModel(selectedRowId));
            setData(data.filter((row) => row.id !== selectedRowId));
            setDeleteDialogOpen(false); // Close the dialog after deletion
         } catch (err) {
            // console.error("Failed to delete model:", err);
         }
      }
   };

   const handleDeleteClick = (id) => {
      setSelectedRowId(id);
      setDeleteDialogOpen(true);
   };

   const handleFocus = (id) => setFocusedInput(id);
   const handleBlur = () => setFocusedInput(null);
   const [columnVisibility, setColumnVisibility] = React.useState(
      columnsData.reduce((acc, column) => {
         acc[column.id] = true;
         return acc;
      }, {}),
   );

   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');

   const columns = columnsData
      .filter((column) => columnVisibility[column.id])
      .map((column) =>
         columnHelper.accessor(column.id, {
            id: column.id,
            header: () => (
               <Text justifyContent="space-between" align="center" fontSize={{ sm: '10px', lg: '12px' }}>
                  {column.header}
               </Text>
            ),
            cell: (info) => <Flex align="center">{info.getValue()}</Flex>,
         }),
      );

   columns.push(
      columnHelper.accessor('id', {
         id: 'id',
         header: () => null,
         cell: (info) => (
            <Flex justify="end">
               <Box className="edit-icon-container">
                  <IconButton
                     aria-label="Edit"
                     icon={<EditIcon />}
                     variant="ghost"
                     colorScheme="brand"
                     onClick={() => {
                        // Create a new object with spread to ensure a fresh reference
                        setCurrentRow({ ...info.row });
                        setIsEditMode(true);
                        onOpen();
                     }}
                  />
                  <IconButton
                     aria-label="Delete"
                     icon={<DeleteIcon />}
                     variant="ghost"
                     colorScheme="red"
                     onClick={() => handleDeleteClick(info.row.id)}
                  />
               </Box>
            </Flex>
         ),
      }),
   );

   const table = useReactTable({
      data,
      columns,
      state: { sorting },
      onSortingChange: setSorting,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const handleSave = (formData) => {
      if (isEditMode && currentRow) {
         setData(data.map((row) => (row.id === currentRow.id ? { ...currentRow, ...formData } : row)));
      } else if (!isEditMode) {
         setData([...data, { ...formData, id: Date.now() }]);
      }
      onClose();
   };

   // --------------------- filter --------------------- //
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const [selectedFilter, setSelectedFilter] = useState(''); // Stores selected filter type
   const [inputValue, setInputValue] = useState('');
   const [NameInputValue, setNameInputValue] = useState(''); // Stores input value
   const [ordinalInputValue, setordinalInputValue] = useState('');
   const [seriesInputValue, setseriesInputValue] = useState('');
   const [colorInputValue, setcolorInputValue] = useState('');
   const [ramInputValue, setramInputValue] = useState('');
   const [storageInputValue, setstorageInputValue] = useState('');
   const [addedName, setAddedName] = useState(''); // Stores final displayed value

   const [ModelData, setModelData] = useState([]);

   useEffect(() => {
      const fetchData = async () => {
         try {
            // const fetchParams = selectedFilter === "option11" ? { type: 'K', name: NameInputValue } : { type: 'K' };

            let fetchParams = {}; // Default fetchParams

            if (selectedColumn?.props?.children === 'NAME' && NameInputValue) {
               fetchParams = selectedFilter === 'option11' ? { name: NameInputValue } : {};
            } else if (selectedColumn?.props?.children === 'ORDINAL' && ordinalInputValue) {
               fetchParams = selectedFilter === 'option11' ? { ordinal: ordinalInputValue } : {};
            } else if (selectedColumn?.props?.children === 'SERIES' && seriesInputValue) {
               fetchParams = selectedFilter === 'option11' ? { series: seriesInputValue } : {};
            } else if (selectedColumn?.props?.children === 'COLOR' && colorInputValue) {
               fetchParams = selectedFilter === 'option11' ? { color: colorInputValue } : {};
            } else if (selectedColumn?.props?.children === 'RAM' && ramInputValue) {
               fetchParams = selectedFilter === 'option11' ? { ram: ramInputValue } : {};
            } else if (selectedColumn?.props?.children === 'STORAGE' && storageInputValue) {
               fetchParams = selectedFilter === 'option11' ? { storage: storageInputValue } : {};
            }
            // else if (selectedColumn?.props?.children === "BALANCE" && balanceInputValue) {
            //   fetchParams = selectedFilter === "option11" ? {  balance: balanceInputValue } : { };
            // }

            // const fetchParams = { type: "K" };
            // if (selectedFilter.includes("name") && nameValue) fetchParams.name = NameInputValue;
            // if (selectedFilter.includes("gst") && gstValue) fetchParams.gst = gstInputValue;
            // if (selectedFilter.includes("pan") && panValue) fetchParams.pan = PanInputValue;
            const response = await dispatch(getModel(fetchParams));

            // const response = await dispatch(
            //     getAccount(selectedFilter === "option3" ? { type: 'K', name: inputValue } : { type: 'K' })
            // );

            // Check if response is an array
            if (response.length > 0 && Array.isArray(response)) {
               setModelData(response);
            } else {
               setModelData([]); // ✅ Prevents 'undefined' error
            }
         } catch (error) {
            console.error('Error fetching data:', error);
            setModelData([]); // ✅ Ensure an empty array is set
         }
      };
      fetchData();
   }, [
      dispatch,
      NameInputValue,
      ordinalInputValue,
      seriesInputValue,
      colorInputValue,
      ramInputValue,
      storageInputValue,
   ]);

   useEffect(() => {
      setData([...ModelData]);
   }, [ModelData]);

   const [isDropdownOpen, setDropdownOpen] = useState(false);

   const toggleDropdown = () => {
      setDropdownOpen(!isDropdownOpen);
   };

   const [selectedColumn, setSelectedColumn] = useState(null);

   const handleImageClick = (columnHeader) => {
      setSelectedColumn(columnHeader); // Store which column was clicked
      setNameInputValue(''); // Reset input value
      setSelectedFilter('');
      setDropdownOpen(true);
      // setIsModalOpen(true); // Open modal
   };

   const handleFilterClick = () => {
      const selectedKey = selectedColumn?.props?.children;

      const inputSetters = {
         NAME: setNameInputValue,
         ORDINAL: setordinalInputValue,
         SERIES: setseriesInputValue,
         COLOR: setcolorInputValue,
         RAM: setramInputValue,
         STORAGE: setstorageInputValue,
      };

      if (selectedKey && inputSetters[selectedKey]) {
         inputSetters[selectedKey](inputValue); // Assign value only on button click
      } else {
         setstorageInputValue(inputValue); // Default case
      }
      // if (selectedFilter === "option11" && NameInputValue) { // "Contains" selected
      //   setAddedName(`name="${NameInputValue}"`);
      // }
      // else {
      //   setAddedName(""); // Reset if filter isn't "Contains" or input is empty
      // }

      setDropdownOpen(false);
   };

   const handlecancelClick = () => {
      setNameInputValue('');
      setSelectedFilter('');
      setDropdownOpen(false);
   };

   const getLeftValue = (column) => {
      switch (column) {
         case 'NAME':
         case 'ORDINAL':
            return '0%';
         case 'SERIES':
         case 'COLOR':
            return '30%';
         case 'STORAGE':
            return '50%';
         default:
            return '70%';
      }
   };

   const handleViewSingleData = async (id) => {
      await dispatch(getSingleModel(id));
      setIsOpenSingleView(true);
   };
   var dynamicArray = [];
   dynamicArray = [
      { label: 'Name', value: singleEntity?.name || '-' },
      { label: 'Series', value: singleEntity?.seriesname || '-' },
      { label: 'Color', value: singleEntity?.color || '-' },
   ];

   return (
      <Card flexDirection="column" w="100%" px="0px" overflowX={{ sm: 'scroll', lg: 'hidden' }} position="relative">
         <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
            <Text color={textColor} fontSize="22px" fontWeight="700" lineHeight="100%">
               Data Table
            </Text>
            <Flex>
               <Select
                  width="auto"
                  marginRight={5}
                  value={pageSize === filteredData.length ? 'ALL' : pageSize.toString()}
                  onChange={handlePageSizeChange}>
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="ALL">All</option>
               </Select>
               <SearchBar
                  mb={() => {
                     return 'unset';
                  }}
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  me="10px"
                  borderRadius="30px"
               />
               <Menu
                  onDownloadPDF={downloadPDF}
                  onDownloadExcel={downloadExcel}
                  columnVisibility={columnVisibility}
                  setColumnVisibility={setColumnVisibility}
               />
               <Button
                  onClick={() => {
                     setCurrentRow({});
                     setIsEditMode(false);
                     onOpen();
                  }}
                  variant="darkBrand"
                  color="white"
                  fontSize="sm"
                  fontWeight="500"
                  borderRadius="full"
                  position="fixed"
                  bottom="20px"
                  right="20px"
                  p={6}
                  zIndex={100}>
                  Add New
               </Button>
            </Flex>
         </Flex>

         {/* Table Rendering */}
         <Box overflowX="auto" className="custom-scrollbar">
            <Table variant="simple" color="gray.500" mb="24px" mt="12px">
               <Thead>
                  {table.getHeaderGroups().map((headerGroup) => (
                     <Tr key={headerGroup.id}>
                        {headerGroup.headers.map((header) => (
                           <Th
                              // borderRight="1px solid"
                              borderTop="1px solid"
                              key={header.id}
                              colSpan={header.colSpan}
                              pe="10px"
                              borderColor={borderColor}
                              cursor="pointer"
                              // onClick={header.column.getToggleSortingHandler()}
                           >
                              <Flex
                                 // justifyContent="space-between"
                                 align="center"
                                 fontSize={{ sm: '10px', lg: '12px' }}
                                 color="gray.400"
                                 id={header.column.columnDef.header}>
                                 <img
                                    src={filter} // If any one is true, show 'filter'
                                    // src={columnImages[header.column.columnDef.header] || filter1}
                                    alt="Filter"
                                    width="12px"
                                    height="12px"
                                    style={{ marginRight: '10px', cursor: 'pointer' }}
                                    id={header.column.columnDef.header}
                                    onClick={() => {
                                       // handleChangeImage();
                                       handleImageClick(header.column.columnDef.header); // Pass column header
                                       toggleDropdown(); // Open/close dropdown
                                    }}
                                 />
                                 <div style={{ marginRight: '10px' }}>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                 </div>
                                 {{
                                    asc: '↑',
                                    desc: '↓',
                                 }[header.column.getIsSorted()] ?? null}
                              </Flex>
                           </Th>
                        ))}
                     </Tr>
                  ))}
               </Thead>
               <Tbody>
                  {/* Dropdown Box (Sliding Effect) */}
                  {isDropdownOpen && selectedColumn?.props?.children && (
                     <Box
                        position="absolute"
                        top="130px" // Dropdown below image
                        left={getLeftValue(selectedColumn?.props?.children)}
                        width="auto"
                        bg={backgroundColor}
                        border="1px solid gray"
                        borderRadius="5px"
                        boxShadow="md"
                        p="2"
                        mt="2"
                        zIndex="10"
                        transition="all 0.2s ease-in-out">
                        <Grid templateColumns="repeat(1, 1fr)" gap={4} p={4}>
                           <Grid justifyContent="center" color={textColor} fontSize="2xl" fontWeight="medium">
                              <label>Select {selectedColumn.props.children.toLowerCase()} Filter</label>
                           </Grid>
                           <hr></hr>
                           {/* Label and Dropdown */}
                           <GridItem display="flex" alignItems="center">
                              <FormLabel htmlFor="dropdown" width="60%" color={textColor}>
                                 Select option
                              </FormLabel>
                              <Select
                                 id="dropdown"
                                 placeholder="Choose an option"
                                 color={textColor}
                                 onChange={(e) => setSelectedFilter(e.target.value)} // Update selected filter
                              >
                                 <option value="option1">Starts With</option>
                                 <option value="option2">Ends With</option>
                                 <option value="option3">Contains</option>
                                 <option value="option4">Equal</option>
                                 <option value="option5">Empty</option>
                                 <option value="option6">Does Not Start With</option>
                                 <option value="option7">Does Not End With</option>
                                 <option value="option8">Does Not Contain</option>
                                 <option value="option9">Not Equal</option>
                                 <option value="option10">Not Empty</option>
                                 <option value="option11">Like</option>
                              </Select>
                           </GridItem>

                           {/* Second Label and Input Box */}
                           <GridItem display="flex" alignItems="center">
                              <FormLabel htmlFor="input1" width="60%" color={textColor}>
                                 Enter the value
                              </FormLabel>
                              <Input
                                 id="input2"
                                 color={textColor}
                                 placeholder="Enter last name"
                                 value={inputValue}
                                 onChange={(e) => setInputValue(e.target.value)}
                              />
                           </GridItem>

                           {/* Button */}
                           <GridItem mt="20px" display="flex" justifyContent="space-between">
                              <Button colorScheme="blue" width="45%" onClick={handleFilterClick}>
                                 Filter
                              </Button>
                              <Button colorScheme="red" width="45%" onClick={handlecancelClick}>
                                 cancel
                              </Button>
                           </GridItem>
                        </Grid>
                     </Box>
                  )}
                  {/* Show No Data Image when paginatedData is empty */}
                  {modelData.length === 0 ? (
                     <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
                        <Td colSpan={columns.length} justifyContent="center" alignItems="center" width="100%">
                           <Grid justifyContent="center" alignItems="center" gap={9}>
                              <img
                                 src={nodata} // Replace with actual image URL
                                 alt="No Data Found"
                                 width="200px"
                                 height="200px"
                              />
                              <GridItem justifySelf="center">
                                 <label>No model data found</label>
                              </GridItem>
                           </Grid>
                        </Td>
                     </Tr>
                  ) : (
                     // Render data rows if available
                     modelData.map((row, rowIndex) => (
                        <React.Fragment key={row.id}>
                           <Tr
                              key={row.id}
                              className="editable-row"
                              _hover={{ bg: 'rgba(0, 63, 140, 0.08)' }}
                              onClick={() => handleViewSingleData(row.id)}>
                              {columns.map((column) => (
                                 <Td
                                    // borderRight="1px solid"
                                    borderColor="gray.200"
                                    key={column.id}
                                    fontSize={{ sm: '14px' }}
                                    minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                                    // borderColor="transparent"
                                 >
                                    {flexRender(column.cell, {
                                       row,
                                       getValue: () => row[column.id],
                                    })}
                                 </Td>
                              ))}
                           </Tr>
                           {/* {rowIndex < paginatedData.length - 1 && (
                  <Tr>
                    <Td colSpan={columns.length} p={0}>
                      <Box
                        borderBottom="1px solid"
                        borderColor="gray.200"
                        my={2}
                        mx="auto"
                        w="98%"
                      />
                    </Td>
                  </Tr>
                )} */}
                        </React.Fragment>
                     ))
                  )}
               </Tbody>
            </Table>
         </Box>

         {/* Pagination Controls */}
         <Flex justify="space-between" px="25px" mb="8px">
            <Flex align="center">
               <Button
                  onClick={() => handlePageChange('prev')}
                  isDisabled={currentPage === 0 || pageSize === filteredData.length}>
                  Previous
               </Button>
               <Text mx="10px">
                  Page {currentPage + 1} of {totalPages}
               </Text>
               <Button
                  onClick={() => handlePageChange('next')}
                  isDisabled={currentPage >= totalPages - 1 || pageSize === filteredData.length}>
                  Next
               </Button>
            </Flex>
         </Flex>
         <ModelMasterForm
            isOpen={isOpen}
            onClose={onClose}
            isEditMode={isEditMode}
            currentRow={currentRow}
            onSave={handleSave}
         />

         <style jsx>{`
            .editable-row {
               position: relative;
               background: ${useColorModeValue('white', 'gray.700')};
               transition: background 0.3s ease;
            }

            .editable-row:hover {
               background: ${useColorModeValue('gray.100', 'gray.600')};
            }

            .editable-row .edit-icon-container {
               display: none;
            }

            .editable-row:hover .edit-icon-container {
               display: block;
               position: absolute;
               right: 10px;
               top: 50%;
               transform: translateY(-50%);
            }
         `}</style>
         <DeleteDialog
            isDeleteDialogOpen={isDeleteDialogOpen}
            setDeleteDialogOpen={setDeleteDialogOpen}
            handleDelete={handleDelete}
            title="Model"
         />
         {/* <ViewSingleData
            isOpenSingleView={isOpenSingleView}
            onClose={() => setIsOpenSingleView(false)}
            entityType="model"
            singleEntity={singleEntity}
            dynamicArray={dynamicArray}
         /> */}
      </Card>
   );
}
